var map = {
	"./demoList1.js": "ake7",
	"./demoList2.js": "jgM+",
	"./index.js": "qs/E"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "nK4b";


//////////////////
// WEBPACK FOOTER
// ./src/mock \.js$
// module id = nK4b
// module chunks = 14